import { caretIcon, h } from '../utils'
import { fieldError } from './error'
import { uniqueId } from './id'
import { fieldLabel } from './label'

interface SelectFieldOptions {
  label: string
  name: string
  choices: { value: string; label: string; disabled?: boolean; selected?: boolean }[]
  defaultValue?: string | null
  placeholder?: string
  required?: boolean
  hidden?: boolean
}

export function selectField(options: SelectFieldOptions) {
  const id = uniqueId()
  const control = h('div', { class: 'vbzc-control' })

  // Select
  const select = h(
    'select',
    { class: 'vbzc-input vbzc-select', id, name: options.name, placeholder: options.placeholder ?? '' },
    { parent: control },
  ) as HTMLSelectElement
  if (options.defaultValue === '') {
    h(
      'option',
      { class: 'vbzc-option', value: '', selected: '', disabled: '' },
      { text: options.label, parent: select },
    )
  }
  for (const choice of options.choices) {
    const props: Record<string, string> = { class: 'vbzc-option', value: choice.value }
    if (choice.disabled) props['disabled'] = ''
    if (choice.selected) props['selected'] = ''
    h('option', props, { text: choice.label, parent: select })
  }

  // Arrow
  control.append(caretIcon('down'))

  // Error
  const { el: error } = fieldError()

  // Field
  const field = h(
    'div',
    { 'class': 'vbzc-field' + (options.hidden ? ' vbzc-field-hidden' : ''), 'data-name': options.name },
    { children: [fieldLabel({ text: options.label, id, required: options.required }), control, error] },
  ) as HTMLDivElement

  return { field, select, error }
}
